.divider-wrapper {
    width: 85%;
    margin: 0 auto;
}
